// extracted by mini-css-extract-plugin
export default {"card":"ServiceCard_card__qWlVP","icon":"ServiceCard_icon__9ZXDq","title":"ServiceCard_title__BD2a9"};